import React from 'react'
import { BOOKMAKER_LOGOS } from '../config/bookmakers'

const formatDateTime = (ts) =>
  new Date(ts + 'Z').toLocaleString('en-US', {
    month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true,
  })

function BookLogo({ name }) {
  if (!name) return null
  return BOOKMAKER_LOGOS[name]
    ? <img src={BOOKMAKER_LOGOS[name]} alt={name} className="bc-book-logo" title={name} />
    : <span className="phm-book-name">{name}</span>
}

export default function HiddenBetsModal({ isOpen, hiddenBets, onUnhide, onUnhideAll, onClose }) {
  if (!isOpen) return null

  const entries = Object.entries(hiddenBets)

  return (
    <>
      <div className="bc-overlay" onClick={onClose} />
      <div className="phm-modal">

        {/* Header */}
        <div className="phm-header">
          <div className="phm-header-left">
            <span className="phm-title">Hidden Bets</span>
            {entries.length > 0 && <span className="phm-count">{entries.length}</span>}
          </div>
          <div className="phm-header-right">
            {entries.length > 0 && (
              <button className="bc-btn phm-unhide-all" onClick={onUnhideAll}>
                Unhide All
              </button>
            )}
            <button className="bc-panel-close" onClick={onClose}>×</button>
          </div>
        </div>

        {/* Body */}
        <div className="phm-body">
          {entries.length === 0 ? (
            <div className="phm-empty">No hidden bets</div>
          ) : (
            entries.map(([key, bet]) => (
              <div key={key} className="phm-row">
                <div className="phm-row-inner">

                  {/* Left — match + outcomes */}
                  <div className="phm-row-info" style={{ flex: 1, minWidth: 0 }}>
                    <div className="phm-sub" style={{ fontWeight: 600, color: '#e2e8f0', marginBottom: '4px' }}>
                      {bet.match}
                    </div>
                    <div className="phm-sub" style={{ marginBottom: '6px' }}>
                      {formatDateTime(bet.commence_time)}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <BookLogo name={bet.bookmaker1} />
                        <span style={{ fontSize: '12px', color: '#cbd5e1' }}>{bet.selection1}</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <BookLogo name={bet.bookmaker2} />
                        <span style={{ fontSize: '12px', color: '#cbd5e1' }}>{bet.selection2}</span>
                      </div>
                    </div>
                  </div>

                  {/* Right — unhide button */}
                  <div className="phm-row-actions">
                    <button
                      className="phm-unhide-btn"
                      onClick={() => onUnhide(key)}
                      data-tooltip="Unhide"
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                    </button>
                  </div>

                </div>
              </div>
            ))
          )}
        </div>

      </div>
    </>
  )
}
